import AuditReportViewPage from "./AuditReportView";
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button, message, Typography, Col, Row } from 'antd';
import axios from '../../../utils/BasicAuthAPI';
import moment from "moment";


const { Text, Link } = Typography;

const AuditReportViewModal = (props) => {
    const [visible, setVisible] = useState(false);

    const sendBackData = (editData) => {
        setVisible(false);
        props.modelCloseHandler(editData);
    }


    const handleCancel = () => {
        setVisible(false);
        props.modelCloseHandler(null, props.editData);
    };

    useEffect(() => {
        if (props.visible) {
            setVisible(props.visible)
        }
    }, [props]);

    useEffect(() => {

    })
    return (
        <React.Fragment>


            <Modal
                title={"Clause Report"}
                open={visible}
                onOk={handleCancel}
                onCancel={handleCancel}
                className={"ThemeModal"}
                width={960}
            >
                <AuditReportViewPage
                    sendBackData={sendBackData}
                    clauseObj={props.clauseObj}
                />


            </Modal>
        </React.Fragment>

    );
};

export default AuditReportViewModal;